<template>

  <div :class="isMobileS?'':'pc'">
    <div class="btn" @click="goNext()" style="margin-bottom:20px;" v-if="isMobileS">投稿入口</div>
    <div class="pc-box">
      <div class="warning">
        <img :src="notice" class="notice"/>
        <div class="title">
          <img :src="isMobileS?icon:iconPc" class="icon"/>
          <h2>长白山新雪季<span>“云顶长白 雪域秘境”</span>影像大赛活动开启啦！</h2>
        </div>
        <p>面向所有摄影创作爱好者，征集摄影照片作品，全面展现长白山冬季的自然风光、冰雪运动、民俗文化等独特魅力。无论你是专业摄影师，还是业余达人，均可参与，用镜头捕捉长白雪山的壮丽神秘。优秀作品将在景区展示，创作者还有机会收获丰厚奖品与荣誉奖牌。
        </p>
        <div class="tip"><span>快来参与</span>，让影像为长白山新雪季增光添彩！</div>
        <div class="foot">长白山党工委宣传部</div>
      </div>
      <div class="warning1">
        <img :src="isMobileS?groupH5:pcgroupH5" class="group"/>
        <div class="title">
          <img :src="isMobileS?icon2:iconPc2" class="icon"/>
          <p>人人都是摄影师，人人都是创作者。通过拍摄身边长白山最美的瞬间，彰显长白山之美，展现长白山神韵，形成宣传长白山的热潮。作品也可延展到吉林省内的其他旅游风光、人文景点、民俗文化、旅游攻略、目的地种草、打卡美照等；邀请市民、游客、全省各高校在籍大学生、摄影师、人民拍客以及爱摄影爱长白山的你广泛参与，欢迎大家踊跃投稿。</p>
        </div>
        <!-- <p>人人都是摄影师，人人都是创作者。通过拍摄身边长白山最美的瞬间，彰显长白山之美，展现长白山神韵，形成宣传长白山的热潮。作品也可延展到吉林省内的其他旅游风光、人文景点、民俗文化、旅游攻略、目的地种草、打卡美照等；邀请市民、游客、全省各高校在籍大学生、摄影师、人民拍客以及爱摄影爱长白山的你广泛参与，欢迎大家踊跃投稿。</p> -->
      </div>
    </div>
      <div class="btn" @click="goNext()" v-if="!isMobileS">投稿入口</div>
    </div>
</template>

<script>
import icon from '@/assets/images/icon.png'
import icon2 from '@/assets/images/icon-2.png'
import iconPc from '@/assets/images/pc-icon.png'
import iconPc2 from '@/assets/images/pc-icon-2.png'
import notice from '@/assets/images/notice.png'
import groupH5 from '@/assets/images/group-h5.png'
import pcgroupH5 from '@/assets/images/pc-group-h5.png'
import noticePc from '@/assets/images/pc-notice.png'
import wxShare from '@/utils/wxshare'
import $ from 'jquery'
export default {
  props: {
    isMobileS: {
      type: Boolean
    }
  },
  data () {
    return {
      data: { },
      icon,
      notice,
      iconPc,
      noticePc,
      icon2,
      iconPc2,
      groupH5,
      pcgroupH5
    }
  },
  mounted () {
    wxShare({
      title: '云顶长白雪域秘境摄影作品大赛',
      desc: '发现身边美 邂逅长白山',
      imgUrl: 'https://cdn2-app.people.cn/static/shareLogo.png'
    }, this)
    document.title = '云顶长白雪域秘境摄影作品大赛'
    $('.content').css('background', '#F0F8FF')

  },
  methods: {
    goNext () {
      this.$emit('goClick', false)
    }
  }
}
</script>
<style>
.content{
  /* background: #F0F8FF; */
  overflow: hidden;
}
</style>
<style scoped lang="less">
  .warning::after{
    content: '';
    display: block;
    clear: both;
    background: url('@/assets/images/content_bg.png') no-repeat 100% 100%;
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
    width: 177px;
    height: 188px;
    right: 0;
    z-index: 1;
  }
  .warning,.warning1{
    // margin:30px;
    background: #FFFFFF;
    box-shadow: 18px 12px 34px -18px rgba(27,58,146,0.16);
    border-radius: 20px;
    margin-bottom:26px;
    position: relative;
    // margin-top:20px;
    .title{
      padding:0 16px 0 14px;
      display: flex;
      margin-top: 30px;
      width: 100%;
      h2{
        font-family: SourceHanSansCN, SourceHanSansCN;
        font-weight: bold;
        font-size: 16px;
        color: #333641;
        line-height: 26px;
        padding-top:25px;
        padding-left:9px;
        // position: relative;
        // z-index: 1;
        // span::after{
        //   content: '';
        //   background: #C8E7FF;
        //   height: 10px;
        //   position: absolute;
        //   width: 242px;
        //   left: 177px;
        //   z-index: -1;
        //   bottom: 24px;
        // }
      }
      .icon{
        width:90px;
        height:71px;
      }
    }
    .notice{
      width:52px;
      height:30px;
      float: right;
    }
    p{
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 16px;
      color: #333641;
      line-height: 24px;
      text-align: justify;
      font-style: normal;
      padding:15px;
      position: relative;
      z-index: 999;
    }
    .tip{
      padding-left:15px;
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: bold;
      font-size: 16px;
      color: #333641;
      line-height: 26px;
      margin-bottom:23px;
      position: relative;
      z-index: 999;
    }
    .tip span{
      color: #0676ED;
    }
    .foot{
      font-family: SourceHanSansCN, SourceHanSansCN;
      font-weight: 500;
      font-size: 14px;
      color: #333641;
      line-height: 16px;
      padding-right: 15px;
      padding-bottom: 15px;
      text-align: right;
      position: relative;
      z-index: 999;
    }
  }
  .btn{
    width: 196px;
    height: 50px;
    background: linear-gradient( 178deg, #0EAEF7 0%, #0676ED 100%);
    box-shadow: 0px 6px 10px 0px rgba(6,118,237,0.3);
    border-radius: 26px;
    font-family: AlibabaPuHuiTi, AlibabaPuHuiTi;
    font-weight: 500;
    font-size: 27px;
    color: #FFFFFF;
    line-height: 37px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
  }
  .warning1{
    .title{
      display: block;
      padding:34px 16px 0 14px;
      .icon{
        width:62px;
        height:65px;
        float: left;
        margin-right: 30px;
      }
      p{
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #333641;
        line-height: 24px;
        text-align: justify;
        font-style: normal;
        padding: 20px 0 30px 0;
        position: relative;
        z-index: 999;
      }
    }
    .group{
      width:80px;
      height:30px;
      float: right;
    }
  }
  .pc{
    padding:15px;
    .pc-box{
      display: flex;
    }
    .warning::after{
      content: '';
      display: block;
      clear: both;
      background: url('@/assets/images/pc_content_bg.png') no-repeat 100% 100%;
      background-size: 100% 100%;
      position: absolute;
      bottom: -3px;
      width: 364px;
      height: 314px;
      right: 0;
      z-index: 1;
    }
    .warning{
      margin-right:30px;
    }
    .warning,.warning1{
      width: 80%;
      background: #FFFFFF;
      box-shadow: 9px 6px 17px -9px rgba(27,58,146,0.16);
      border-radius: 10px;
      //margin:0 auto;
      //margin-top:40px;
      p,.tip{
        margin:0 auto;
        font-size: 26px;
        line-height: 44px;
        position: relative;
        margin-left: 127px;
        padding-right: 40px;
        font-weight: bold;
        padding-top: 0;
       // top: -22px;
      }
      .tip{
        margin-left:146px;
      }
      .tip>span{
        padding-left: 18px;
        color:#333641;
      }
      .tip>span::before{
        content: '';
        background: #0676ED;
        width: 12px;
        height: 12px;
        position: absolute;
        left: 0;
        top: 18px;
        border-radius: 50%;
      }
      .title {
        padding: 0 16px 0 36px;
        h2{
          font-weight: bold;
          font-size: 26px;
          padding-top: 18px;
          position: relative;
          z-index: 1;
          line-height: 44px;
          // span::after{
          //   content: '';
          //   background: #C8E7FF;
          //   height: 14px;
          //   position: absolute;
          //   width: 242px;
          //   left: 177px;
          //   z-index: -1;
          //   bottom: 24px;
          // }
        }
      }
      .foot{
        font-weight: 500;
        font-size: 22px;
        font-family: SourceHanSansCN, SourceHanSansCN;
        margin-bottom:16px;
        margin-top:20px;
      }
      .icon{
        width:96px;
        height:75px;
      }
      .notice{
        width:90px;
        height:48px;
        float: right;
      }
    }
    .btn{
      margin-top:20px;
      margin-bottom:40px;
      cursor: pointer;
    }
    .warning1{
      .icon{
        width: 62px;
        height: 65px;
        margin-right: 20px;
      }
      .group{
        width:148px;
        height:48px;
      }
      .title{
        display: flex;
      }
      p{
        margin-left:0;
        top:-5px;
        padding-top: 15px;
      }
    }
  }
  </style>
